import { solid } from '@fortawesome/fontawesome-svg-core/import.macro'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import { Nav, Navbar } from 'react-bootstrap'
import IconButton from './IconButton'
import LocaleSelector from './LocaleSelector'
import Logo from './Logo'
import UserMenu from './UserMenu'

type Props = {
  showSidebar: React.MouseEventHandler<HTMLButtonElement>;
}

export default function AppNavbar({ showSidebar }: Props) {
  return (
    <Navbar className="py-1 border-bottom" bg="light">
      <IconButton className="mx-2" onClick={showSidebar}>
        <FontAwesomeIcon icon={solid('bars')} />
      </IconButton>
      <Logo className="p-1 px-2" />

      <Nav className="flex-row align-items-center ms-auto pe-3">
        <LocaleSelector />
        <UserMenu className="ms-2" />
      </Nav>
    </Navbar>
  )
}